import { Injectable } from '@angular/core';
import {ToastController} from 'ionic-angular';

@Injectable()
export class TokenManager {

	private token:any;

	constructor(private toastCtrl:ToastController){
		this.token = "";
	}

	getToken(){
		return this.token;
	}

	setToken(token){
		this.token = token;
	}
	

}


// WEBPACK FOOTER //
// ./src/providers/token-manager.ts